export const PROJECT_NAME = 'CAO';
